import type { STEP_NAME } from 'src/app/components/Pages/LoggedInTransfer/Experiment/types';
import type { MedicationSearchResult } from 'src/app/types';

import { usePersistentData } from '../usePersistentData';

const DATA = 'LOGGED_IN_TRANSFER_FORM_DATA';
const PROGRESS = 'LOGGED_IN_TRANSFER_FORM_PROGRESS';

const VERSION = '1';

export const LOGGED_IN_TRANSFER_FORM_DATA_KEY = `${DATA}.${VERSION}`;
export const LOGGED_IN_TRANSFER_FORM_PROGRESS_KEY = `${PROGRESS}.${VERSION}`;

export interface LoggedInTransferForm {
  patientId?: string;
  patientName?: string;
  patientIsPrimary?: boolean;
  pharmacyName?: string;
  pharmacyAddress?: string;
  pharmacyPhone?: string;
  pharmacyZipCode?: string;
  pharmacyZipCodeLatitude?: string;
  pharmacyZipCodeLongitude?: string;
  birthdate?: string;
  medications?: MedicationSearchResult[];
  doctorName?: string;
  doctorPhone?: string;
  shouldTransferAllMeds?: boolean;
}

export interface TransferFormProgress {
  steps?: STEP_NAME[];
  currentStepIndex?: number;
}

export function useLoggedInTransferFormData() {
  const { data, setData } = usePersistentData<LoggedInTransferForm>(LOGGED_IN_TRANSFER_FORM_DATA_KEY);
  const dataObj = data ? (JSON.parse(data) as LoggedInTransferForm) : null;

  return {
    loggedInTransferFormData: dataObj,
    setLoggedInTransferFormData: async (newContext: LoggedInTransferForm) => {
      await setData(newContext);
    },
  };
}

export function useLoggedInTransferFormProgress() {
  const { data, setData } = usePersistentData<TransferFormProgress>(LOGGED_IN_TRANSFER_FORM_PROGRESS_KEY);
  const dataObj = data ? (JSON.parse(data) as TransferFormProgress) : null;

  return {
    loggedInTransferFormProgress: dataObj,
    setLoggedInTransferFormProgress: async (newContext: TransferFormProgress) => {
      await setData(newContext);
    },
  };
}
